import { initExclusiveRadioSubmitGuard } from '../shared/exclusive-radio-submit-guard';

/**
 * Wires the school ledger panel's manual entry modals: the Credit/Debit radios
 * of the new and edit modals to the shared exclusive-radio submit guard, the
 * edit modal's reset on close, and the delete modal's confirm button so a
 * double-click cannot post twice.
 */
export function initManualLedgerEntryModal(): void {
    const modal = document.getElementById('manualLedgerEntryModal');
    if (modal) {
        initExclusiveRadioSubmitGuard(modal, 'manualEntryCredit', 'manualEntryDebit', 'manualLedgerEntrySubmitBtn');
    }

    const editModal = document.getElementById('editManualLedgerEntryModal');
    if (editModal) {
        // The edit modal opens with the entry's direction already checked, so its submit
        // button renders enabled and the guard only has to keep it in step from there.
        initExclusiveRadioSubmitGuard(editModal, 'editEntryCredit', 'editEntryDebit', 'editManualLedgerEntrySubmitBtn');
        initEditModalReset(editModal);
    }

    const deleteModal = document.getElementById('deleteManualLedgerEntryModal');
    const deleteBtn = deleteModal?.querySelector<HTMLButtonElement>('#deleteManualLedgerEntrySubmitBtn');
    if (deleteBtn) {
        // Native full-page-reload POST: disabling here only blocks a second click
        // after this one is already underway.
        deleteModal?.querySelector('form')?.addEventListener('submit', () => {
            deleteBtn.disabled = true;
        });
    }
}

/**
 * Puts the edit modal back to the entry's saved values whenever it closes, so
 * changes abandoned with Cancel are not still there, ready to be saved, the
 * next time it opens. The form's default values are the ones the server rendered.
 */
function initEditModalReset(editModal: HTMLElement): void {
    const form = editModal.querySelector('form');
    if (!form) return;

    editModal.addEventListener('hidden.bs.modal', () => {
        form.reset();

        // reset() restores the amount's raw rendered value ("250.00"); the currency
        // input formats it as "$250.00" on blur, as it does on page load.
        form.querySelectorAll<HTMLInputElement>('[data-currency-input]').forEach((input) => {
            input.dispatchEvent(new Event('blur'));
        });
    });
}
